import { STORAGE_KEYS } from "@/lib/storage-keys";

/** A different/imported backup must not clear other devices' server bindings. */
export function markPrfBackupStale(): void {
	localStorage.removeItem(STORAGE_KEYS.PRF_VAULT_CATALOG);
	window.dispatchEvent(new Event("prf-credential-hydrated"));
}
